import React from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

import backgroundImg from './img/background.png'

import backgroundImgM from './img/backgroundM.png'

import vectorImg from './img/vector.png'

const Intro = ({
  coupleData: { coupleFirstName },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro360">
      <div className="animated-intro-small-all-breakpoints animated-intro-large screen">
        <img
          className="background hide-on-768"
          src={background || backgroundImgM}
          alt="Background"
        />
        <img
          className="background hide-on-320"
          src={background || backgroundImg}
          alt="Background"
        />
        <div className="mask_background" />
        <div className="button-kaVUlA button-p4EdWL">
          <div
            className="site-de-casamento-e site-de-casamento-e-CpwLjN"
            dangerouslySetInnerHTML={{ __html: warningMessage }}
          />
          <div className="button-gcDLS5 button-CpwLjN smart-layers-pointers">
            <div
              className="pular-introduo pular-introduo-fo8x79"
              onClick={onSkipIntro}
            >
              {buttonMessage}
            </div>
          </div>
        </div>
        <div className="couple-name-animated-intro-small-all-breakpoints hide-on-768 bp2-animate-enter2">
          <div className="mari-1 hide-on-768 madecanvas-black-seashell-peach-72px bp2-animate-enter">
            {coupleFirstName.bride}
          </div>
          <img className="vector hide-on-768" src={vectorImg} alt="Vector" />
          <div className="dudu-1 hide-on-768 madecanvas-black-seashell-peach-72px bp2-animate-enter1">
            {coupleFirstName.groom && `${coupleFirstName.groom}`}
          </div>
        </div>
        <div className="couple-name-animated-intro-large hide-on-320 bp1-animate-enter2">
          <div className="mari-2 hide-on-320 madecanvas-black-seashell-peach-72px bp1-animate-enter">
            {coupleFirstName.bride}
          </div>
          <img className="vector hide-on-320" src={vectorImg} alt="Vector" />
          <div className="dudu-2 hide-on-320 madecanvas-black-seashell-peach-72px bp1-animate-enter1">
            {coupleFirstName.groom && `${coupleFirstName.groom}`}
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
